// extracted by mini-css-extract-plugin
export var icon3 = "pageLikes-module--icon3--0xvLo";
export var icon2 = "pageLikes-module--icon2--zh0lP";
export var icon1 = "pageLikes-module--icon1--sBnIs";
export var iconCloud = "pageLikes-module--iconCloud--CaBW-";